/** @module */
import { mapGetters } from 'vuex';

/**
 * @description appGuard, automatically send users to login when they are not logged in
 * @param {*} signInRoute $router.replace parameter to send the user to sign in
 * @returns {void}
 * @example
 * // In your VueJS auth index component
 * import { appGuard } from '@tokenyico/vuejs-toolkit/src/mixins/guards';
 *   export default {
 *   name: 'AppIndex',
 *   mixins: [appGuard({ name: 'sign-in' })],
 * }
 */
export function appGuard (signInRoute) {
  return {
    computed: mapGetters({
      isLoggedIn: 'tokeny/isLoggedIn'
    }),
    beforeRouteEnter (_to, _from, next) {
      next((vm) => {
        if (!vm.isLoggedIn) {
          vm.$router.replace(signInRoute);
          return false;
        }
      });
    },
    watch: {
      isLoggedIn () {
        // we have assured this is true, it can only change to false
        this.$router.replace(signInRoute);
        this.$logger.success(this.$t('VT.logoutToast'));
      }
    }
  };
}

/**
 * @description authGuard, automatically send users to the app home when they are logged in
 * @param {*} appHomeRoute $router.replace parameter to send the user to the application home
 * @returns {void}
 * @example
 * // In your VueJS auth index component
 * import { authGuard } from '@tokenyico/vuejs-toolkit/src/mixins/guards';
 *   export default {
 *   name: 'AppIndex',
 *   mixins: [authGuard({ name: 'app-index' })],
 * }
 */
export function authGuard (appHomeRoute) {
  return {
    computed: mapGetters({
      isLoggedIn: 'tokeny/isLoggedIn'
    }),
    beforeRouteEnter (_to, _from, next) {
      next((vm) => {
        if (vm.isLoggedIn) {
          vm.$router.replace(appHomeRoute);
          return false;
        }
      });
    },
    watch: {
      isLoggedIn () {
        // we have assured this is false, it can only change to true
        this.$router.replace(appHomeRoute);
        this.$logger.success(this.$t('VT.loginToast'));
      }
    }
  };
}
